import { Inject, Injectable } from '@angular/core';
import { MsisdnHelperService } from '../../utils/services/msisdn-helper.service';
import SlotStateService from '../../cart-process/slot-state.service';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { ModalLoaderData } from '../../utils/loaders/modal-loader.service';
import { LoadersService } from '../../utils/loaders/loaders.service';
import { LoaderActions } from '../../utils/loaders/loader-actions.enum';
import { IDrawnNumber } from '../../interfaces/draw-number.interface';
import SlotFirstPageModel from '../../models/slot-first-page.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';

@Injectable()
export default class DrawingNewNumberService {

  constructor(
    @Inject('Endpoint') private endpoint: any,
    private slotStateService: SlotStateService,
    private msisdnHelperService: MsisdnHelperService,
    private commonModalService: CommonModalService,
    private loadersService: LoadersService,
    private commonInfo: CommonInfoService
  ) {

  }

  public randomNumberFailure(slot: any): void {
    const modalData = {
      templateName: CommonModalTemplatesEnum.LOTTERY_NUMBER_FAILURE,
      retry: (event: Event) => {
        event.preventDefault();
        this.selectNewNumber(slot);
      },
      isVirginBrand: this.commonInfo.isVirginBrand
    };

    this.commonModalService.setData(modalData);
  }

  public setNewNumberOnSlot(slot: SlotFirstPageModel, newMsisdn: string): void {
    if (!slot == null && !newMsisdn == null) {
      return;
    }

    slot.setMsisdn(newMsisdn);

    this.slotStateService.setOriginalState(slot);
    this.slotStateService.restoreSlotState(slot.bundleNumber);
  }

  public setNewNumberOnEntry(slot: SlotFirstPageModel, newMsisdn: string): void {
    if (!slot == null && !newMsisdn == null) {
      return;
    }

    this.endpoint('msisdn.selectMsisdn', {
      bundleNo: slot.bundleNumber,
      msisdn: newMsisdn
    }).run()
      .then(() => {
        console.info('selectMsisdn');
      });
  }

  public selectNewNumber(slot: SlotFirstPageModel): void {
    const DRAWING_NEW_NUMBER_TEXT = `Losowanie nowego numeru w ${this.commonInfo.isVirginBrand ? 'Virgin' : 'Play'}`;
    if (slot == null) {
      return;
    }

    this.loadersService.start(
      LoaderActions.MODAL_LOADER,
      new ModalLoaderData(
        DRAWING_NEW_NUMBER_TEXT,
        true
      ),
      true
    );
    this.endpoint('msisdn.msisdn', {
      bundleNo: slot.bundleNumber
    }).run()
      .then((msisdnsResponse: any) => {
        this.showModalWithNumbers(msisdnsResponse, slot);
      })
      .catch((error: any) => {
        console.error('selectNewNumber - ERROR');
        console.error(error);

        this.randomNumberFailure(slot);
      });
  }

  public showModalWithNumbers(msisdnsResponse: IDrawnNumber[], slot: SlotFirstPageModel): void {
    this.loadersService.stop(LoaderActions.MODAL_LOADER)
      .runAfterDelay(() => {
        this.processingResponseWithMsisdns(msisdnsResponse, slot);
      });
  }

  public processingResponseWithMsisdns(msisdnsResponse: IDrawnNumber[], slot: SlotFirstPageModel): void {
    if (Array.isArray(msisdnsResponse)) {
      const modalData = {
        templateName: CommonModalTemplatesEnum.DRAWING_NEW_NUMBERS,
        newNumbers: msisdnsResponse,
        selectedMsisdn: msisdnsResponse[0],
        isVirginBrand: this.commonInfo.isVirginBrand,
        selectNumberModal: (event: Event): void => {
          event.preventDefault();

          this.selectNumberModal(slot, modalData.selectedMsisdn);
        },
        getNextNumbers: (event: Event): void => {
          event.preventDefault();

          this.selectNewNumber(slot);
        }
      };

      this.commonModalService.setData(modalData);
    }
  }

  private selectNumberModal(slot: SlotFirstPageModel, selectedMsisdn: IDrawnNumber): void {
    this.setNewNumberOnSlot(slot, this.msisdnHelperService.unformatMsisdn(selectedMsisdn.number));
    this.setNewNumberOnEntry(slot, selectedMsisdn.number);

    this.commonModalService.removeModal(CommonModalTemplatesEnum.DRAWING_NEW_NUMBERS);
  }
}




